
import React from "react";
import { Helmet } from "react-helmet-async";

const AdminSettings: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Admin Settings - OGMAI</title>
      </Helmet>
      <div className="p-6">
        <h1 className="text-3xl font-bold mb-6">Admin Settings</h1>
        <p className="text-muted-foreground">Configure system settings.</p>
      </div>
    </>
  );
};

export default AdminSettings;
